import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
const _ = require('lodash');

import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { SeedFulfillmentService } from './../../../services/seed/seed-fulfillment.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CommonService } from './../../../services/common/common.service';

import { MasterConstants } from './../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../app/models/DashboardFilter';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-efulfillmentfilter',
  templateUrl: './efulfillment-filter.component.html',
  styleUrls: ['./efulfillment-filter.component.scss']
})

export class efulfillmentfilterComponent implements OnDestroy {
  private subscription = new Array<Subscription>();
  filtersValue: any;
  accountDataCount: number;

  selectedFilter: string;
  filterValueList: any[] = [];

  filterToApply: any[];
  defaultFilterToSet: any[];

  isFulfillment: boolean;
  headerYear: any;
  headerCompany: any;
  isFilterAction = false;
  IsClearFilter: boolean;
  searchButtonClick = false;
  @Input()
  disableSearchBtn: false;

  @Input()
  IsAccountTab: false;

  @Input()
  IsEmulationTab: false;

  @Input()
  IsPartnerWebSiteTab: false;

  @Input()
  IsFulfilmentTab: false;

  @Input()
  IsFilterData: false;

  @Input()
  set cleanFilter(val: boolean) {
    this.IsClearFilter = val;
    if (val) {
      this.clearAllFilter();
    }
  }
  get cleanFilter(): boolean {
    return this.IsClearFilter;
  }

  @Input()
  set IsFulfillment(val: boolean) {
    this.isFulfillment = val;
  }
  get IsFulfillment(): boolean {
    return this.isFulfillment;
  }

  @Input()
  set filters(val: any[]) {
    this.filterToApply = val;
    if (val[0]) { this.selectedFilter = val[0].column; }
  }
  get filters(): any[] {
    return this.filterToApply;
  }

  @Input()
  set defaultfilters(val: any[]) {
    this.defaultFilterToSet = val;
  }
  get defaultfilters(): any[] {
    return this.defaultFilterToSet;
  }

  @Output()
  SearchFilter: EventEmitter<any> = new EventEmitter<any>();

  accountDS: any[] = [];
  stateDS: any[] = [];

  // Account Type dropdown data (all account types); displayText = "[Description] - [Code]"
  accountTypeDS: any[] = [
    { code: 'C', description: 'CUSTOMER PARENT', displayText: 'CUSTOMER PARENT - C' },
    { code: 'CB', description: 'CUSTOMER BILL TO ONLY', displayText: 'CUSTOMER BILL TO ONLY - CB' },
    { code: 'CC', description: 'COUNTER SALE CUSTOMER', displayText: 'COUNTER SALE CUSTOMER - CC' },
    { code: 'CD', description: 'CUSTOMER DELIVER TO ONLY', displayText: 'CUSTOMER DELIVER TO ONLY - CD' },
    { code: 'CS', description: 'CUSTOMER SHIP TO', displayText: 'CUSTOMER SHIP TO - CS' },
    { code: 'CP', description: 'CUSTOMER GRANDPARENT', displayText: 'CUSTOMER GRANDPARENT - CP' },
    { code: 'E', description: 'EMPLOYEE', displayText: 'EMPLOYEE - E' },
    { code: 'V', description: 'VENDOR', displayText: 'VENDOR - V' }
  ];

  marketingMasterList: any = [];
  seedSizeMasterList: any = [];
  packageSizeMasterList: any = [];
  productCategoryMasterList: any = [];
  treatmentMasterList: any = [];
  productLineMasterList: any = [];
  productSegmentMasterList: any = [];
  hybridVarietyMasterList: any = [];
  branchPlantList: any = [];
  requestTypeList: any = [];

  constructor(public commonService: CommonService, public toastrService: ToastrService, private localStorageService: LocalStorageService,
    public seedFulfillmentService: SeedFulfillmentService, private broadcastService: BroadcastService, private configService: ConfigService) {
    this.filtersValue = {};
    this.resetFilterInputValue();

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    if (this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST)) {
      this.productCategoryMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST));
    }
    if (this.localStorageService.get(MasterConstants.PRODUCT_SEGMENT_MASTER_LIST)) {
      this.productSegmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_SEGMENT_MASTER_LIST));
    }

    this.subscription.push(this.commonService.getHybridVarietyMasterData().subscribe((result: any) => {
      this.hybridVarietyMasterList = result;
    }));

    if (this.localStorageService.get(MasterConstants.VERSION_CONTROL_MASTER_LIST)) {
      this.requestTypeList = JSON.parse(this.localStorageService.get(MasterConstants.VERSION_CONTROL_MASTER_LIST));
    }
    if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
      this.branchPlantList = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
      this.branchPlantList.filter(x => x.data == this.headerCompany);
    }

    this.subscription.push(this.broadcastService.on<any>(this.configService.SET_CLEAR_EMULATION).subscribe((data) => {
      this.clearAllFilter();
      this.getFilterDropDownData();
    }));

    this.searchButtonClick = false;
  }

  ngOnInit() {
    if (!this.IsFilterData) {
      this.getFilterDropDownData();
    }
  }
  // Get the filter data for dropdown in filte component
  getFilterDropDownData() {
    if (this.headerCompany == undefined && this.headerYear == undefined) {
      this.subscription.push(this.commonService.getFilterDDLData().subscribe(result => {
        const data = result as commonDDL;
        this.stateDS = data.states;
        this.accountDS = data.accounts;
        this.accountDataCount = this.accountDS.length;
      }, error => LolLoggerService.error(error)));
    }
    else {
      this.subscription.push(this.commonService.getFilterDDLData().subscribe(result => {
        const data = result as commonDDL;
        this.stateDS = data.states;
        this.accountDS = data.accounts;
        this.accountDataCount = this.accountDS.length;
      }, error => LolLoggerService.error(error)));
    }
  }

  keepFilter() {
    const accountNo = +this.filtersValue.accountNo;
    if (isNaN(accountNo)) {
      this.filtersValue.accountNo = '';
      this.toastrService.error('Invalid Input.');
      return false;
    }

    // Create filterValueList from Filters
    this.filterValueList = [];

    if (this.filtersValue.accountName && this.filtersValue.accountName != '') {
      this.filterValueList.push({ column: 'accountName', filterlabel: 'Account Name : ' + this.filtersValue.accountName, data: this.filtersValue.accountName });
    }
    if (this.filtersValue.accountNo && this.filtersValue.accountNo != '') {
      this.filterValueList.push({ column: 'accountNo', filterlabel: 'Account Number : ' + this.filtersValue.accountNo, data: this.filtersValue.accountNo });
    }
    if (this.filtersValue.city && this.filtersValue.city != '') {
      this.filterValueList.push({ column: 'city', filterlabel: 'City : ' + this.filtersValue.city, data: this.filtersValue.city });
    }
    if (this.filtersValue.state && this.filtersValue.state != '') {
      this.filterValueList.push({ column: 'state', filterlabel: 'State / Province : ' + this.filtersValue.state, data: this.filtersValue.state });
      const stateObj = this.stateDS.filter(x => x.value == this.filtersValue.state);
      this.filtersValue.stateId = stateObj[0].id;
    }
    if (this.filtersValue.phoneNo && this.filtersValue.phoneNo != '') {
      this.filterValueList.push({ column: 'phoneNo', filterlabel: 'PhoneNo : ' + this.filtersValue.phoneNo, data: this.filtersValue.phoneNo });
    }
    if (this.filtersValue.name && this.filtersValue.name != '') {
      this.filterValueList.push({ column: 'name', filterlabel: 'Name: ' + this.filtersValue.name, data: this.filtersValue.name });
    }
    if (this.filtersValue.address && this.filtersValue.address != '') {
      this.filterValueList.push({ column: 'address', filterlabel: 'Address : ' + this.filtersValue.address, data: this.filtersValue.address });
    }
    if (this.filtersValue.zip && this.filtersValue.zip != '') {
      this.filterValueList.push({ column: 'zip', filterlabel: 'ZIP : ' + this.filtersValue.zip, data: this.filtersValue.zip });
    }
    if (this.filtersValue.accountDDL && this.filtersValue.accountDDL != '') {
      this.filterValueList.push({ column: 'accountDDL', filterlabel: 'account : ' + this.filtersValue.accountDDL, data: this.filtersValue.accountDDL });
    }

    // Added some new filters

    // product name
    if (this.filtersValue.productName && this.filtersValue.productName != '') {
      this.filterValueList.push({ column: 'productName', filterlabel: 'Product Name : ' + this.filtersValue.productName, data: this.filtersValue.productName });
    }

    // itemNumber
    if (this.filtersValue.itemNumber && this.filtersValue.itemNumber != '') {
      this.filterValueList.push({ column: 'itemNumber', filterlabel: 'Item Numnber : ' + this.filtersValue.itemNumber, data: this.filtersValue.itemNumber });
    }

    // marketing brand
    if (this.filtersValue.marketingBrand && this.filtersValue.marketingBrand != '') {
      const marketingBrand = this.marketingMasterList.find(x => x.id == this.filtersValue.marketingBrand);
      if (marketingBrand) {
        this.filterValueList.push({ column: 'marketingBrand', filterlabel: 'Marketing Brand : ' + marketingBrand.value, data: this.filtersValue.marketingBrand });
      }
    }

    // seed size
    if (this.filtersValue.seedSize && this.filtersValue.seedSize != '') {
      const seedSize = this.seedSizeMasterList.find(x => x.id == this.filtersValue.seedSize);
      if (seedSize) {
        this.filterValueList.push({ column: 'seedSize', filterlabel: 'Seed Size : ' + seedSize.value, data: this.filtersValue.seedSize });
      }
    }

    // package size
    if (this.filtersValue.packageSize && this.filtersValue.packageSize != '') {
      const packageSize = this.packageSizeMasterList.find(x => x.id == this.filtersValue.packageSize);
      if (packageSize) {
        this.filterValueList.push({ column: 'packageSize', filterlabel: 'Package Size : ' + packageSize.value, data: this.filtersValue.packageSize });
      }
    }

    // product category
    if (this.filtersValue.productCategory && this.filtersValue.productCategory != '') {
      const productCategory = this.productCategoryMasterList.find(x => x.id == this.filtersValue.productCategory);
      if (productCategory) {
        this.filterValueList.push({ column: 'productCategory', filterlabel: 'Product Category : ' + productCategory.value, data: this.filtersValue.productCategory });
      }
    }

    // treatment
    if (this.filtersValue.treatment && this.filtersValue.treatment != '') {
      const treatment = this.treatmentMasterList.find(x => x.id == this.filtersValue.treatment);
      if (treatment) {
        this.filterValueList.push({ column: 'treatment', filterlabel: 'Treatment : ' + treatment.value, data: this.filtersValue.treatment });
      }
    }

    // product line
    if (this.filtersValue.productLine && this.filtersValue.productLine != '') {
      const productLine = this.productLineMasterList.find(x => x.id == this.filtersValue.productLine);
      if (productLine) {
        this.filterValueList.push({ column: 'productLine', filterlabel: 'Product Line : ' + productLine.value, data: this.filtersValue.productLine });
      }
    }

    // product segment
    if (this.filtersValue.productSegment && this.filtersValue.productSegment != '') {
      const productSegment = this.productSegmentMasterList.find(x => x.id == this.filtersValue.productSegment);
      if (productSegment) {
        this.filterValueList.push({ column: 'productSegment', filterlabel: 'Product Segment : ' + productSegment.value, data: this.filtersValue.productSegment });
      }
    }

    // hybrid variety
    if (this.filtersValue.hybridVariety && this.filtersValue.hybridVariety != '') {
      const hybridVariety = this.hybridVarietyMasterList.find(x => x.id == this.filtersValue.hybridVariety);
      if (hybridVariety) {
        this.filterValueList.push({ column: 'hybridVariety', filterlabel: 'Hybrid Variety : ' + hybridVariety.value, data: this.filtersValue.hybridVariety });
      }
    }

    // dealer zip
    if (this.filtersValue.dealerZip && this.filtersValue.dealerZip != '') {
      this.filterValueList.push({ column: 'dealerZip', filterlabel: 'Dealer Zip : ' + this.filtersValue.dealerZip, data: this.filtersValue.dealerZip });
    }

    // branch plant
    if (this.filtersValue.branchPlant && this.filtersValue.branchPlant != '') {
      this.filterValueList.push({ column: 'branchPlant', filterlabel: 'Branch Plant : ' + this.filtersValue.branchPlant, data: this.filtersValue.branchPlant });
    }

    // order type
    if (this.filtersValue.orderType && this.filtersValue.orderType != '') {
      this.filterValueList.push({ column: 'orderType', filterlabel: 'Order Type : ' + this.filtersValue.orderType, data: this.filtersValue.orderType });
    }

    // End add some new filters
    this.SearchFilter.emit(this.filtersValue);
  }

  accountkeepFilter() {
    const format = /^[0-9,\s]+$/;
    if (this.filtersValue.accountNo && this.filtersValue.accountNo != ''
      && !format.test(this.filtersValue.accountNo)) {
      this.toastrService.warning('Invalid Account No.');
      this.filtersValue.accountNo = '';
      return false;
    }

    // Create filterValueList from Filters
    this.filterValueList = [];

    if (this.filtersValue.accountName && this.filtersValue.accountName != '') {
      this.filterValueList.push({ column: 'accountName', filterlabel: 'Account Name : ' + this.filtersValue.accountName, data: this.filtersValue.accountName });
    }
    if (this.filtersValue.accountNo && this.filtersValue.accountNo != '') {
      this.filterValueList.push({ column: 'accountNo', filterlabel: 'Account Number : ' + this.filtersValue.accountNo, data: this.filtersValue.accountNo });
    }
    if (this.filtersValue.accountTypeDescriptionWithCode && this.filtersValue.accountTypeDescriptionWithCode != '') {
      const selectedCodes = Array.isArray(this.filtersValue.accountTypeDescriptionWithCode)
        ? this.filtersValue.accountTypeDescriptionWithCode
        : [this.filtersValue.accountTypeDescriptionWithCode];
      const accountTypeLabels = selectedCodes.map(code => {
        const selectedAccountType = this.accountTypeDS.find(x => x.code == code);
        return selectedAccountType ? selectedAccountType.description : code;
      });
      this.filterValueList.push({ column: 'accountTypeDescriptionWithCode', filterlabel: 'Account Type : ' + accountTypeLabels.join(', '), data: this.filtersValue.accountTypeDescriptionWithCode });
    }
    if (this.filtersValue.city && this.filtersValue.city != '') {
      this.filterValueList.push({ column: 'city', filterlabel: 'City : ' + this.filtersValue.city, data: this.filtersValue.city });
    }
    if (this.filtersValue.state && this.filtersValue.state != '') {
      this.filterValueList.push({ column: 'state', filterlabel: 'State / Province : ' + this.filtersValue.state, data: this.filtersValue.state });
    }
    if (this.filtersValue.parentName && this.filtersValue.parentName != '') {
      this.filterValueList.push({ column: 'parentName', filterlabel: 'Parent Name : ' + this.filtersValue.parentName, data: this.filtersValue.parentName });
    }
    if (this.filtersValue.parentNumber && this.filtersValue.parentNumber != '') {
      this.filterValueList.push({ column: 'parentNumber', filterlabel: 'Parent Number : ' + this.filtersValue.parentNumber, data: this.filtersValue.parentNumber });
    }

    if (this.isFilterAction && this.filtersValue &&
      ((!this.filtersValue.accountName || this.filtersValue.accountName == '') &&
        (!this.filtersValue.accountNo || this.filtersValue.accountNo == '') &&
        (!this.filtersValue.accountTypeDescriptionWithCode || this.filtersValue.accountTypeDescriptionWithCode == '') &&
        (!this.filtersValue.city || this.filtersValue.city == '') &&
        (!this.filtersValue.state || this.filtersValue.state == '') &&
        (!this.filtersValue.parentName || this.filtersValue.parentName == '') &&
        (!this.filtersValue.parentNumber || this.filtersValue.parentNumber == ''))) {
      this.toastrService.warning('Please Select Filter');
      this.isFilterAction = false;
      return false;
    }
    this.isFilterAction = false;
    this.SearchFilter.emit(this.filtersValue);
  }

  emulationKeepFilter() {
    const accountNo = +this.filtersValue.account;
    if (isNaN(accountNo)) {
      this.filtersValue.account = '';
      return false;
    }

    // Create filterValueList from Filters
    this.filterValueList = [];

    if (this.filtersValue.accountName && this.filtersValue.accountName != '') {
      this.filterValueList.push({ column: 'accountName', filterlabel: 'Account Name: ' + this.filtersValue.accountName, data: this.filtersValue.accountName });
    }
    if (this.filtersValue.account && this.filtersValue.account != '') {
      this.filterValueList.push({ column: 'account', filterlabel: 'Account: ' + this.filtersValue.account, data: this.filtersValue.account });
    }
    if (this.filtersValue.city && this.filtersValue.city != '') {
      this.filterValueList.push({ column: 'city', filterlabel: 'City : ' + this.filtersValue.city, data: this.filtersValue.city });
    }
    if (this.filtersValue.state && this.filtersValue.state != '') {
      this.filterValueList.push({ column: 'state', filterlabel: 'State / Province : ' + this.filtersValue.state, data: this.filtersValue.state });
    }
    if (this.filtersValue.parentName && this.filtersValue.parentName != '') {
      this.filterValueList.push({ column: 'parentName', filterlabel: 'Parent Name : ' + this.filtersValue.parentName, data: this.filtersValue.parentName });
    }
    if (this.filtersValue.parentNumber && this.filtersValue.parentNumber != '') {
      this.filterValueList.push({ column: 'parentNumber', filterlabel: 'Parent Number : ' + this.filtersValue.parentNumber, data: this.filtersValue.parentNumber });
    }
    if (this.filtersValue &&
      (!this.filtersValue.account &&
        (!this.filtersValue.accountName || this.filtersValue.accountName == '') &&
        (!this.filtersValue.city || this.filtersValue.city == '') &&
        (!this.filtersValue.state || this.filtersValue.state == '') &&
        (!this.filtersValue.parentName || this.filtersValue.parentName == '') &&
        (!this.filtersValue.parentNumber || this.filtersValue.parentNumber == ''))) {
      if (this.searchButtonClick) {
        this.toastrService.warning('Please Select Filter');
      }
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.SearchFilter.emit(null);
      return false;
    }
    this.SearchFilter.emit(this.filtersValue);
  }

  clearAllFilter() {
    if (this.filterValueList.length > 0) {
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.SearchFilter.emit(null);
    }
  }

  clearFilter(column: string) {
    this.removeProductFilter(column);
    this.filterValueList = this.filterValueList.filter(x => column.trim() != x.column.trim());
    this.SearchFilter.emit(this.filtersValue);
  }

  onFilter() {
    if (this.IsAccountTab) {
      this.isFilterAction = true;
      this.accountkeepFilter();
    }
    else if (this.IsFulfilmentTab) {
      this.keepFilter();
    }
    else if (this.IsEmulationTab) {
      this.searchButtonClick = true;
      this.emulationKeepFilter();
    }
    else if (this.IsPartnerWebSiteTab) {
      this.searchButtonClick = true;
      this.emulationKeepFilter();
    }
  }

  // To remove clear search filter
  removeProductFilter(column) {
    switch (column) {
      case 'accountName':
        this.filtersValue.accountName = null;
        break;
      case 'accountNo':
        this.filtersValue.accountNo = null;
        break;
      case 'accountTypeDescriptionWithCode':
        this.filtersValue.accountTypeDescriptionWithCode = null;
        break;
      case 'state':
        this.filtersValue.state = null;
        this.filtersValue.stateId = null;
        break;
      case 'city':
        this.filtersValue.city = null;
        break;
      case 'name':
        this.filtersValue.name = null;
        break;
      case 'phoneNo':
        this.filtersValue.phoneNo = null;
        break;
      case 'zip':
        this.filtersValue.zip = null;
        break;
      case 'address':
        this.filtersValue.address = null;
        break;
      case 'accountDDL':
        this.filtersValue.accountDDL = null;
        break;
      case 'productName':
        this.filtersValue.productName = null;
        break;
      case 'marketingBrand':
        this.filtersValue.marketingBrand = null;
        break;
      case 'seedSize':
        this.filtersValue.seedSize = null;
        break;
      case 'packageSize':
        this.filtersValue.packageSize = null;
        break;
      case 'productCategory':
        this.filtersValue.productCategory = null;
        break;
      case 'treatment':
        this.filtersValue.treatment = null;
        break;
      case 'productLine':
        this.filtersValue.productLine = null;
        break;
      case 'productSegment':
        this.filtersValue.productSegment = null;
        break;
      case 'hybridVariety':
        this.filtersValue.hybridVariety = null;
        break;
      case 'dealerZip':
        this.filtersValue.dealerZip = null;
        break;
      case 'branchPlant':
        this.filtersValue.branchPlant = null;
        break;
      case 'orderType':
        this.filtersValue.orderType = null;
        break;
      case 'account':
        this.filtersValue.account = null;
        break;
      case 'parentName':
        this.filtersValue.parentName = null;
        break;
      case 'parentNumber':
        this.filtersValue.parentNumber = null;
        break;
      default:
        break;
    }
  }

  resetFilterInputValue() {
    this.filtersValue.accountNo = null;
    this.filtersValue.accountName = null;
    this.filtersValue.accountTypeDescriptionWithCode = null;
    this.filtersValue.city = null;
    this.filtersValue.state = null;
    this.filtersValue.phoneNo = null;
    this.filtersValue.name = null;
    this.filtersValue.address = null;
    this.filtersValue.zip = null;
    this.filtersValue.state = null;
    this.filtersValue.accountDDL = null;
    this.filtersValue.marketingBrand = null;
    this.filtersValue.seedSize = null;
    this.filtersValue.packageSize = null;
    this.filtersValue.productCategory = null;
    this.filtersValue.treatment = null;
    this.filtersValue.productLine = null;
    this.filtersValue.productSegment = null;
    this.filtersValue.hybridVariety = null;
    this.filtersValue.dealerZip = null;
    this.filtersValue.branchPlant = null;
    this.filtersValue.orderType = null;
    this.filtersValue.stateId = null;
    this.filtersValue.account = null;
    this.filtersValue.itemNumber = null;
    this.filtersValue.parentName = null;
    this.filtersValue.parentNumber = null;
  }

  // Search the state details dropdown
  stateSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1
      || item.value.toLocaleLowerCase().toString().indexOf(term) > -1;
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  emulationAccountSearchFn($event: string) {
    let list: any;
    list = _.filter(this.accountDS, item => item.accountName == null ? false : item.accountName.toLocaleLowerCase().indexOf($event) > -1
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toString().indexOf($event) > -1)
      || (item.zipCode == null ? false : item.zipCode.toString().indexOf($event) > -1)
      || (item.accountNumber == null ? false : item.accountNumber.toString().indexOf($event) > -1)
      || (item.parentName == null ? false : item.parentName.toString().indexOf($event) > -1)
      || (item.parentNumber == null ? false : item.parentNumber.toString().indexOf($event) > -1));
    this.accountDataCount = list.length;
  }

  emulationAccountFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.accountName == null ? false : item.accountName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toString().indexOf(term) > -1)
      || (item.zipCode == null ? false : item.zipCode.toString().indexOf(term) > -1)
      || (item.accountNumber == null ? false : item.accountNumber.toString().indexOf(term) > -1)
      || (item.parentName == null ? false : item.parentName.toString().indexOf(term) > -1)
      || (item.parentNumber == null ? false : item.parentNumber.toString().indexOf(term) > -1);
  }
}

export class commonDDL {
  accounts: any[];
  states: any[];
}
